import { SelectorOptions } from 'shared/newEntities/components/Selector';

export interface IBaseTag {
  id: string;
  name: string;
}

export interface IProjectTag extends IBaseTag {
  usersCount: number;
  dateCreated: Date;
  dateUpdated: Date;
}

export const buildTagOptions = (tags: IBaseTag[]): SelectorOptions => {
  return tags.reduce(
    (acc, tag) => {
      acc.keys.push(tag.id);
      acc.entities[tag.id] = {
        id: tag.id,
        title: tag.name
      };

      return acc;
    },
    { keys: [], entities: {} } as SelectorOptions
  );
};
